import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
const Signup = () => {
  return <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8" data-id="element-1246">
      <div className="max-w-md w-full space-y-8" data-id="element-1247">
        <div className="text-center" data-id="element-1248">
          <h1 className="text-3xl font-bold text-gray-900" data-id="element-1249">
            Create your account
          </h1>
          <p className="mt-2 text-gray-600" data-id="element-1250">
            Join our community of developers and employers
          </p>
        </div>
        <div className="bg-white p-8 rounded-lg shadow-sm border border-[#FF3B30]" data-id="element-1251">
          <form className="space-y-6" data-id="element-1252">
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2" data-id="element-1253">
              <div data-id="element-1254">
                <label htmlFor="first_name" className="block text-sm font-medium text-gray-700" data-id="element-1255">
                  First name
                </label>
                <input id="first_name" name="first_name" type="text" required className="mt-1 block w-full px-3 py-2 border border-[#FF3B30] rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-[#FF3B30] focus:border-[#FF3B30]" data-id="element-1256" />
              </div>
              <div data-id="element-1257">
                <label htmlFor="last_name" className="block text-sm font-medium text-gray-700" data-id="element-1258">
                  Last name
                </label>
                <input id="last_name" name="last_name" type="text" required className="mt-1 block w-full px-3 py-2 border border-[#FF3B30] rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-[#FF3B30] focus:border-[#FF3B30]" data-id="element-1259" />
              </div>
            </div>
            <div data-id="element-1260">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-1261">
                Email address
              </label>
              <input id="email" name="email" type="email" autoComplete="email" required className="mt-1 block w-full px-3 py-2 border border-[#FF3B30] rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-[#FF3B30] focus:border-[#FF3B30]" placeholder="you@example.com" data-id="element-1262" />
            </div>
            <div data-id="element-1263">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-1264">
                Password
              </label>
              <input id="password" name="password" type="password" autoComplete="new-password" required className="mt-1 block w-full px-3 py-2 border border-[#FF3B30] rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-[#FF3B30] focus:border-[#FF3B30]" data-id="element-1265" />
              <p className="mt-1 text-xs text-gray-500" data-id="element-1266">
                Password must be at least 8 characters and include a number and
                special character.
              </p>
            </div>
            <div data-id="element-1267">
              <label htmlFor="account_type" className="block text-sm font-medium text-gray-700" data-id="element-1268">
                I am a...
              </label>
              <select id="account_type" name="account_type" className="mt-1 block w-full px-3 py-2 border border-[#FF3B30] rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-[#FF3B30] focus:border-[#FF3B30]" data-id="element-1269">
                <option value="developer" data-id="element-1270">Developer</option>
                <option value="employer" data-id="element-1271">Employer</option>
                <option value="agency" data-id="element-1272">Agency / Team</option>
              </select>
            </div>
            <div className="flex items-center" data-id="element-1273">
              <input id="terms" name="terms" type="checkbox" required className="h-4 w-4 text-[#FF3B30] focus:ring-[#FF3B30] border-[#FF3B30] rounded shadow-sm" data-id="element-1274" />
              <label htmlFor="terms" className="ml-2 block text-sm text-gray-700" data-id="element-1275">
                I agree to the{' '}
                <Link to="/terms-of-service" className="text-blue-600 hover:text-blue-500" data-id="element-1276">
                  Terms of Service
                </Link>{' '}
                and{' '}
                <Link to="/privacy-policy" className="text-blue-600 hover:text-blue-500" data-id="element-1277">
                  Privacy Policy
                </Link>
              </label>
            </div>
            <div data-id="element-1278">
              <Button type="submit" variant="primary" fullWidth data-id="element-1279">
                Create Account
              </Button>
            </div>
          </form>
          <div className="mt-6" data-id="element-1280">
            <div className="relative" data-id="element-1281">
              <div className="absolute inset-0 flex items-center" data-id="element-1282">
                <div className="w-full border-t border-gray-300" data-id="element-1283" />
              </div>
              <div className="relative flex justify-center text-sm" data-id="element-1284">
                <span className="px-2 bg-white text-gray-500" data-id="element-1285">
                  Or sign up with
                </span>
              </div>
            </div>
            <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-1286">
              <div data-id="element-1287">
                <a href="#" className="w-full inline-flex justify-center py-2 px-4 border border-[#FF3B30] rounded-md shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-1288">
                  <span className="sr-only" data-id="element-1289">Sign up with GitHub</span>
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" data-id="element-1290">
                    <path fillRule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z" clipRule="evenodd" data-id="element-1291" />
                  </svg>
                </a>
              </div>
              <div data-id="element-1292">
                <a href="#" className="w-full inline-flex justify-center py-2 px-4 border border-[#FF3B30] rounded-md shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-1293">
                  <span className="sr-only" data-id="element-1294">Sign up with Google</span>
                  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-1295">
                    <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" data-id="element-1296" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-1297">
          <p className="text-sm text-gray-600" data-id="element-1298">
            Already have an account?{' '}
            <Link to="/login" className="font-medium text-blue-600 hover:text-blue-500" data-id="element-1299">
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </div>;
};
export default Signup;